var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CountByCountry',{staticClass:"mb-3"}),_c('CountByPartner',{staticClass:"mb-3"}),_c('CountByStage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }